import { Controller } from "@hotwired/stimulus"
import { navigator } from '@hotwired/turbo'
import { useMutation } from "stimulus-use"

/*
  INFO: Workaround to update the browser URL based on the actions inside the
  Availabilities grid.

  Issue:
  https://github.com/hotwired/turbo/issues/50

  Workaround:
  https://gist.github.com/Intrepidd/ac68cb7dfd17d422374807efb6bf2f42
*/
export default class extends Controller {
  connect () {
    useMutation(this, { attributes: true })
  }

  mutate (entries) {
    entries.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        const src = this.element.getAttribute('src')
        if (src != null) { navigator.history.push(new URL(src)) }
      }
    })
  }
}
